import React from 'react'
import AdminNav from '../../Components/Admin/AdminNavbar/AdminNav'
import StudioUnvarified from '../../Components/Admin/StudioManagement/StudioUnvarified'

function StudiovarifyPage() {
  return (
    <div>
      <AdminNav/>
      <StudioUnvarified/>
    </div>
  )
}

export default StudiovarifyPage
